module.exports = __webpack_public_path__ + "assets/img/sea2.0fc32ce6.png";